import { PageHero, Section, SectionHeading, Seo, Reveal, breadcrumb } from "@/components/site/Section";
import { FinalCTA } from "@/components/site/HomeSections";
import { KINGSMOSS_URL, trackKingsmossClick } from "@/lib/referral";

const VALUES = [
  { t: "Local", d: "A Northern Ireland business delivering to Northern Ireland homes." },
  { t: "Reliable", d: "A regular monthly delivery you can count on, so you never run out." },
  { t: "Quality", d: "Kiln-dried logs that are ready to burn, with kindling and firelighters included." },
];

export default function About() {
  return (
    <>
      <Seo title="About Us — Local Log Delivery in Newtownabbey" path="/about" jsonLd={breadcrumb("About Us", "/about")} description="WeeLogRun offers flexible monthly firewood subscriptions in Newtownabbey and BT36–BT39, working with local supplier Kingsmoss Logs NI." />
      <PageHero eyebrow="About us" title="Local logs, delivered with care." intro="WeeLogRun is your local log membership delivery team for Newtownabbey and surrounding areas." image="/img/logs-ends.jpg" />
      <Section>
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal className="overflow-hidden rounded-[2rem] border border-[#262626]">
              <img src="/img/logs-stack.jpg" alt="Stacked firewood logs" className="h-[460px] w-full object-cover" loading="lazy" />
            </Reveal>
          </div>
          <div className="lg:col-span-7 space-y-5 text-base leading-relaxed text-[#F7F5F0]/80">
            <SectionHeading eyebrow="Our story" title="Local firewood, made simple." />
            <p>WeeLogRun was created around one simple idea: one less thing to think about.</p>
            <p>We know that remembering to order logs isn't always convenient, especially when life gets busy.</p>
            <p>That's why we offer flexible monthly firewood subscriptions, bringing logs, kindling and firelighters straight to your door across BT36, BT37, BT38 and BT39. You can pause, change or cancel online whenever you need to.</p>
            <p>
              Working with local firewood supplier{" "}
              <a href={KINGSMOSS_URL} target="_blank" rel="noopener" onClick={() => trackKingsmossClick("about")}
                className="text-[#FF6A00] underline-offset-4 hover:underline" data-testid="about-kingsmoss-link">Kingsmoss Logs NI</a>, we make it easier to keep your home stocked throughout the year.
            </p>
          </div>
        </div>
      </Section>
      <Section className="bg-[#0b0b0b]">
        <SectionHeading eyebrow="What we stand for" title="Warmth, reliability and quality." />
        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {VALUES.map((v, i) => (
            <Reveal key={v.t} delay={i * 0.08}>
              <div className="h-full rounded-3xl border border-[#262626] bg-[#111] p-8">
                <p className="font-display text-3xl font-bold text-[#FF6A00]">{v.t}</p>
                <p className="mt-3 text-[15px] text-[#A1A1AA]">{v.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </Section>
      <FinalCTA />
    </>
  );
}
